import type { FC, ReactNode } from 'react'
import React from 'react'
import type { FabProps } from '@material-ui/core/Fab'
import Fab from '@material-ui/core/Fab'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { SvgIconProps } from '@material-ui/core'
import { SvgIcon } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      fontSize: '16px',
      fontWeight: 500,
      letterSpacing: '-0.15px',
      lineHeight: '26px',
      height: 42,
      textTransform: 'none',
      maxWidth: 160,
      width: '100%',
      position: 'fixed',
      bottom: 30,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1,
      '& svg': {
        marginRight: 5,
      },
    },
  }),
)
interface IProps extends FabProps {
  svgIcon?: string
  rotateIcon?: number
  className?: string
  disabled?: boolean
  children: ReactNode
}

const iconTypes = {
  filters: <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />,
}

function Icon(props: SvgIconProps) {
  return <SvgIcon {...props}>{props.children}</SvgIcon>
}

const FloatingButton: FC<IProps> = ({
  children,
  svgIcon,
  className,
  ...rest
}) => {
  const classes = useStyles()

  const builtInIcon = iconTypes?.[svgIcon]

  return (
    <Fab className={clsx(classes.root, className)} {...rest}>
      {builtInIcon && <Icon fill={'FFFFFF'}>{builtInIcon}</Icon>}
      {children && children}
    </Fab>
  )
}

export default FloatingButton
